import React from 'react'
import { useQuery } from '@apollo/client';
import { Trans } from 'react-i18next';
import { GET_VEHICLE_BY_SOURCE_ID } from '../../../../GraphQL/Queries/vehicles';
import { LoadingIcon } from '../../../Common/Loading_Icon';

const EUVehicleSpecification = ({ vehicle, vehicle_options, vehicle_details, isLoading, ...props }) => {

  const [specSheetUrl, setSpecSheetUrl] = React.useState()
  const { queryIsLoading, data } = useQuery(GET_VEHICLE_BY_SOURCE_ID, {
    variables: { sourceVehicleId: Number(props.match.params.v_id) }
  });

  const openSpecSheet = () => {
    var win = window.open(specSheetUrl);
    win.focus();
  }

  React.useEffect(() => {
    if (!data) return
    setSpecSheetUrl(data?.getVehicleBySourceVehicleId?.specSheetUrl || vehicle.Catalogue_Link)

    return () => {
      setSpecSheetUrl(undefined)
    }
  }, [data, vehicle])

  return (
    <div className="eu-vehicle--header-specs">
      <h4 style={{ display: "flex" }}>
        <span style={{ marginRight: "auto" }}><Trans>Specifications</Trans></span>
        {
          specSheetUrl && <a style={{ marginLeft: "auto", cursor: "pointer" }} onClick={openSpecSheet}><i className="far fa-file overlay_header_info_action_item_icon"></i><Trans>Spec Sheet</Trans></a>
        }
      </h4>
      <div className="eu-vehicle--spec-wrapper">
        {
          !isLoading || !queryIsLoading ?
            <>
              <div className="spec-item">
                {console.log('vehicle_options.engine', vehicle_options.engine)}
                <div className="spec-item--left">
                  <div className="spec-item--icon">
                    <img src={vehicle_options.engine.image} />
                  </div>
                  <p><Trans>{vehicle_options.engine.name}</Trans></p>
                </div>
                <div className="spec-item--right">
                  <p>{vehicle_details.engine_opt[vehicle.Engine]}</p>
                </div>
              </div>
              <div className="spec-item">
                <div className="spec-item--left">
                  <div className="spec-item--icon">
                    <img src={vehicle_options.transmission.image} />
                  </div>
                  <p>{vehicle_options.transmission.name}</p>
                </div>
                <div className="spec-item--right">
                  <p>{vehicle_details.trans_opt[vehicle.Transmission]}</p>
                </div>
              </div>
              <div className="spec-item">
                <div className="spec-item--left">
                  <div className="spec-item--icon">
                    <img src={vehicle_options.roof.image} />
                  </div>
                  <p><Trans>{vehicle_options.roof.name}</Trans></p>
                </div>
                <div className="spec-item--right">
                  <p>{vehicle_details.roof_opt[vehicle.Roof]}</p>
                </div>
              </div>
              <div className="spec-item">
                <div className="spec-item--left">
                  <div className="spec-item--icon">
                    <img src={vehicle_options.tires.image} />
                  </div>
                  <p><Trans>{vehicle_options.tires.name}</Trans></p>
                </div>
                <div className="spec-item--right">
                  <p>{vehicle_details.tires_opt[vehicle.Tires]}</p>
                </div>
              </div>
              <div className="spec-item">
                <div className="spec-item--left">
                  <div className="spec-item--icon">
                    <img src={vehicle_options.exterior.image} />
                  </div>
                  <p><Trans>{vehicle_options.exterior.name}</Trans></p>
                </div>
                <div className="spec-item--right">
                  <p>{vehicle.Exterior_Exact_Color}</p>
                </div>
              </div>
              {
                "interior" in vehicle_options ?
                  <div className="spec-item">
                    <div className="spec-item--left">
                      <div className="spec-item--icon">
                        <img src={vehicle_options.interior.image} />
                      </div>
                      <p><Trans>{vehicle_options.interior.name}</Trans></p>
                    </div>
                    <div className="spec-item--right">
                      <p>{vehicle.Interior_Exact_Color}</p>
                    </div>
                  </div>
                  :
                  null
              }
              <div className="spec-item">
                <div className="spec-item--left">
                  <div className="spec-item--icon">
                    <img src={vehicle_options.drive_train.image} />
                  </div>
                  <p><Trans>{vehicle_options.drive_train.name}</Trans></p>
                </div>
                <div className="spec-item--right">
                  <p>{vehicle_details.drive_train_opt[vehicle.Drive_Train]}</p>
                </div>
              </div>
              <div className="spec-item">
                <div className="spec-item--left">
                  <div className="spec-item--icon">
                    <img src={vehicle_options.body_type.image} />
                  </div>
                  <p><Trans>{vehicle_options.body_type.name}</Trans></p>
                </div>
                <div className="spec-item--right">
                  <p>{vehicle_details.body_style_opt[vehicle.Body_Style]}</p>
                </div>
              </div>
            </>
            :
            <LoadingIcon />
        }
      </div>
    </div>
  )
}

export default EUVehicleSpecification